import React, { useEffect, useMemo, useState } from "react";
import Card from "../../../components/common/Card";
import Paper from "@mui/material/Paper";
import DateRangePickerComponent from "../../../components/common/DateRangePickerComponent";
import "./TrackVehicle.css";
import ReactMuiTable from "../../../components/common/ReusableTable/ReactTable";
import ColumnFilter from "../../../components/common/ColumnFilter";
import {
  getAllTripDetails,
  getShiftDetails1,
  getSiteDetails,
  updateTripDetails,
  vehicleListVendors,
  vehicleTypes,
  viewTripDetails,
} from "../../../services/vehicleService";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useFormik, validateYupSchema } from "formik";
import { withErrorHandler } from "../../../utils/tryCatchHandler";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { setLoader } from "../../../redux/features/authSliceandSidebar";
import {
  FormControl,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import ConfimationModal from "../../../components/modals/ConfirmationModal";
import * as Yup from "yup";
import { toast } from "react-toastify";
import TripDetailsForm from "../../../components/common/TripDetailForm";
import { useNavigate } from "react-router-dom";
import { DateRangePicker } from "rsuite";

const TrackVehicle = () => {
  const [activeTab, setActiveTab] = useState("permanent");
  const [searchQuery, setSearchQuery] = useState("");
  // const [dateRange, setDateRange] = useState({ start: '', end: '' });
  const [selectedRadio, setSelectedRadio] = useState("active");
  const [prefilledFields, setPrefilledFields] = useState([]);

  const [showObj, setShowObj] = useState(null);

  const [detailObj, setDetailObj] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  const validationSchema = Yup.object({
    startReading: Yup.number()
      .typeError("Start Reading must be a number")
      .required("Start Reading is required"),
    endReading: Yup.number()
      .typeError("End Reading must be a number")
      .required("End Reading is required"),
    workingHours: Yup.number()
      .typeError("Working Hours must be a number")
      .required("Working Hours is required"),
    kmClosing: Yup.number()
      .typeError("KM Closing must be a number")
      .required("KM Closing is required"),
    kmCovered: Yup.number()
      .typeError("KM Covered must be a number")
      .required("KM Covered is required"),
  });

  let today = new Date();
  let yesterday = new Date(today);
  console.log(yesterday.getDate());

  const [key, setKey] = useState(Math.random());
  const [key1, setKey1] = useState(Math.random());
  const [previousDate, setPreviousDate] = useState(new Date());
  const [dateRange, setDateRange] = useState([
    new Date(today.getFullYear(), today.getMonth(), 1),
    new Date(),
  ]);
  const [formData, setFormData] = useState({
    employeeType: "permanent",
    department: "",
    employeeId: "",
    fullName: "",
    contact: "",
    email: "",
  });

  const defaultColumn = useMemo(() => {
    return {
      Filter: ColumnFilter,
    };
  }, []);
  const [pageIndex, setPageIndex] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(5);
  const [pageSize1, setPageSize1] = React.useState(5);
  const [pageIndex1, setPageIndex1] = React.useState(0);
  const [activeId, setActiveId] = useState(0);
  const isLogin = useSelector((x) => x.authSliceandSidebar.isLogin);
  const dispatch = useDispatch();
  const [tripData, setTripData] = useState([]);
  const [allTripData, setAllTripData] = useState([]);

  const navigate = useNavigate();

  const [vehicleList, setVehicleList] = useState([]);
  const [sitesList, setSitesLsit] = useState([]);
  const [shiftList, setShiftList] = useState([]);
  const [showModal1, setShowModal1] = useState(false);

  const [showModal2, setShowModal2] = useState(false);

  const fullData = [
    "startReading",
    "endReading",
    "workingHours",
    "kmOpening",
    "kmClosing",
    "kmCovered",
    "id",
  ];

  const rawColumns = [
    { Header: "TripId", accessor: "tripId" },
    { Header: "Name", accessor: "vehicleName" },
    {
      Header: "Vehicle No.",
      accessor: "vehicleNumber",
      Cell: (cell) => {
        return (
          <>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                setSelectedRow(null);
                handleMenuClick(e, cell.row.original);
              }}
            >
              {" "}
              {cell.row.original.vehicleNumber}{" "}
            </a>
          </>
        );
      },
    },
    {
      Header: "Trip Date",
      accessor: "tripDate",
      Cell: (cell) => {
        return cell?.row?.original?.tripDate
          ? moment(cell.row.original.tripDate).format("DD-MM-YYYY")
          : "";
      },
    },
    { Header: "Shift Name", accessor: "shiftName" },
    { Header: "Vendor Name", accessor: "vendorName" },
    { Header: "Start Reading", accessor: "startReading" },
    { Header: "End Reading", accessor: "endReading" },
    { Header: "Working hours", accessor: "workingHours" },
    { Header: "Trip Count", accessor: "tripsCount" },

    {
      Header: "Actions",
      Footer: "User-Action",
      accessor: "actio1n",
      Cell: (cell) => {
        return (
          <>
            <IconButton
              title={"Actions "}
              onClick={(e) => {
                setSelectedRow(null);
                handleMenuClick(e, cell.row.original);
              }}
            >
              <MoreVertIcon />
            </IconButton>
          </>
        );
      },
      disableFilters: true,
    },
  ];

  const table1Columns = [
    { Header: "Vehicle Type", accessor: "vehicleTypeName" },
    {
      Header: "Trip Day",
      accessor: "tripDay",
      Cell: (cell) => {
        return moment(cell.row.original.tripDay).format("DD-MMM-YYYY");
      },
    },
    {
      Header: "Total Wrk Hrs",
      accessor: "totalWorkingHours",
      Cell: (cell) => {
        return (
          <p style={{ marginRight: "64px" }}>
            {cell.row.original.totalWorkingHours}
          </p>
        );
      },
    },
    {
      Header: "Total Trips",
      accessor: "totalTrips",
      Cell: (cell) => {
        return (
          <p style={{ marginRight: "64px" }}>{cell.row.original.totalTrips}</p>
        );
      },
    },
    // {
    //   Header: "Total Trips Count",
    //   accessor: "totalTrips",
    //   Cell: (cell) => {
    //     return (
    //       <p style={{ marginRight: "64px" }}>{cell.row.original.totalTrips}</p>
    //     );
    //   },
    // },
    {
      Header: "Hard Trips",
      accessor: "hardTrips",
      Cell: (cell) => {
        return (
          <p style={{ marginRight: "34px", justifyContent: "left" }}>
            {cell.row.original.totalHardTrips}
          </p>
        );
      },
    },
    {
      Header: "Soft Trips",
      accessor: "softTrips",
      Cell: (cell) => {
        return <> {cell.row.original.totalSoftTrips}</>;
      },
    },
  ];

  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleMenuClick = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleEdit = () => {
    console.log("Edit", selectedRow);

    if (!(selectedRow.endReading || selectedRow.kmClosing)) {
      editDetail(selectedRow);
    } else {
      handleClose();
      toast.warn("Trip only updated for End Reading once");
    }
    handleClose();
  };

  const columns = React.useMemo(() => {
    return rawColumns;
  }, []);

  const columns1 = React.useMemo(() => {
    return table1Columns;
  }, []);

  const paginatedData = React.useMemo(() => {
    const start = pageIndex * pageSize;
    return tripData?.slice(start, start + pageSize);
  }, [pageIndex, pageSize, tripData]);
  /**
   * Returns a paginated slice of all trip data based on current page index and size
   * @example
   * () => {
   *   const start = pageIndex * pageSize;
   *   return allTripData?.slice(start, start + pageSize);
   * }
   * @param {number} pageIndex - The current page index for pagination.
   * @param {number} pageSize - The number of records per page.
   * @returns {array} A slice of the allTripData array containing data for the current page.
   * @description
   *   - Uses React's `useMemo` hook to optimize rendering by memoizing the paginated data.
   *   - Handles edge cases such as missing or undefined arrays with optional chaining.
   */
  const paginatedData1 = React.useMemo(() => {
    const start = pageIndex1 * pageSize1;
    return allTripData?.slice(start, start + pageSize1);
  }, [pageIndex1, pageSize1, allTripData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const viewDetail = (cell) => {
    setDetailObj(selectedRow);
    setShowModal1(true);
    handleClose();
  };

  const editDetail = (selectedRow) => {
    // console.log(cell.row.original);
    setDetailObj(selectedRow);
    formik1.setValues(selectedRow);
    formik1.setFieldValue("id", selectedRow?.tripId);
    // setShowModal2(true);
    localStorage.setItem("detailsObj", JSON.stringify(selectedRow));
    navigate("/editTrips");
    // EditVendorDetailsApi(selectedRow);
  };

  const EditVendorDetailsApi = async (details) => {
    console.log(details);
    let formdata = {
      vehicleTypeId: details.vehicleTypeId,
      shiftId: details.shiftId,
      siteId: details.siteId,
      tripDate: details.tripDate,
      fieldCategory: details.vehicleType,
      fieldMenu: "Edit Trip Details",
    };

    await vehicleListVendors(formdata).then((res) => {
      dispatch(setLoader(false));
      if (res && res.data?.statusDescription?.statusCode == 200) {
      } else if (res.data?.statusDescription?.statusCode == 220) {
        toast.warn(res.data.statusDescription.description);
      }
    });
    console.log(formdata);
  };

  function toNormalCase(key) {
    return key
      ?.replace(/([A-Z])/g, " $1")
      ?.replace(/^./, (str) => str.toUpperCase()) // capitalize first letter
      .trim(); // remove any leading space
  }
  useEffect(() => {
    if (isLogin) {
      dispatch(setLoader(true));
      // getVehiclees();
      // getSites();

      getVehiclees()
        .then(getSites)
        .then(getShiftDetails)
        .then((res) => {
          document.getElementById("go_for_hit")?.click();
        });
    }
  }, [isLogin]);

  const getSites = async () => {
    setSitesLsit([]);
    withErrorHandler(
      await getSiteDetails().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          // console.log(res.data);
          setSitesLsit(res.data.siteDetails);
          formik.setFieldValue(
            "tripDate",
            moment(new Date()).format("YYYY-MM-DD")
          );
          formik.setFieldValue("siteIdState", res.data.siteDetails[0]);
          formik.setFieldValue("siteId", res.data.siteDetails[0].siteId);
        } else if (res && res.data.statusDescription?.statusCode == 401) {
          dispatch(setLoader(false));
        }
      })
    );
  };

  const getShiftDetails = async () => {
    setShiftList([]);
    withErrorHandler(
      await getShiftDetails1().then((res) => {
        if (res && res.data.statusDescription?.statusCode == 200) {
          setShiftList(res.data.shiftDetails);
          formik.setFieldValue("shiftId", res.data.shiftDetails[0].shiftId);

          formik.setFieldValue("shiftName", res.data.shiftDetails[0].name);
          dispatch(setLoader(false));
          // setSelectedRadio(res.data.shiftDetails[0].shiftId);
        } else {
        }
      })
    );
  };

  const getVehiclees = async () => {
    setVehicleList([]);
    withErrorHandler(
      await vehicleTypes().then((res) => {
        console.log(res.data.data);

        if (res && res.data.statusDescription?.statusCode == 200) {
          let arr = res.data.data;
          arr.unshift({
            vehicleTypeId: -1,
            category: "All",
            name: "All",
            id: 0,
          });
          console.log(arr);
          setVehicleList(arr);
          if (localStorage.getItem("vehicleName") != null) {
            setActiveTab(localStorage.getItem("vehicleName"));
            setActiveId(localStorage.getItem("vehicleTypeId"));
            formik.setFieldValue(
              "vehicleTypeId",
              localStorage.getItem("vehicleTypeId")
            );
            formik.setFieldValue(
              "vehicleName",
              localStorage.getItem("vehicleName")
            );
          } else {
            setActiveTab(arr[0].name);
            setActiveId(arr[0].vehicleTypeId);
            formik.setFieldValue("vehicleTypeId", arr[0].vehicleTypeId);
            formik.setFieldValue("vehicleName", arr[0].name);
          }
        } else {
        }
      })
    );
  };

  const formik = useFormik({
    initialValues: {
      siteId: null,
      shiftId: null,
      tripDate: null,
      siteIdState: null,
      tripDateState: new Date(),
      vehicleTypeId: null,
      vehicleName: "",
      shiftName: "",
      startDate: null,
      endDate: null,
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),

    onSubmit: async (values) => {
      dispatch(setLoader(true));
      // console.log(values);
      setTripData([]);
      setAllTripData([]);
      let formdata = { ...values };
      delete formdata["siteIdState"];
      delete formdata["tripDateState"];
      console.log(dateRange);
      delete formdata["tripDate"];

      formdata["startDate"] = moment(dateRange[0]).format("YYYY-MM-DD");
      formdata["endDate"] = moment(dateRange[1]).format("YYYY-MM-DD");

      console.log(activeId);
      console.log(activeTab);

      if (activeId == -1) {
        //Loading..
        await getAllTripDetails(formdata).then((res) => {
          if (res && res?.data?.statusDescription?.statusCode == 200) {
            console.log(res.data);
            dispatch(setLoader(false));
            setAllTripData(res.data.tripStats);
          }
        });
      } else {
        await viewTripDetails(formdata).then((res) => {
          dispatch(setLoader(false));
          if (res && res?.data?.statusDescription?.statusCode == 200) {
            setTripData(
              res.data.tripdetaillog1.sort((a, b) => b.tripId - a.tripId)
            );
          }
        });
      }
    },
  });

  const formik1 = useFormik({
    initialValues: {
      id: 0,
      startReading: "",
      endReading: "",
      workingHours: "",
      kmOpening: "",
      kmClosing: "",
      kmCovered: "",
      meterFiles: [],
      meterFiles1: [],
    },
    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    // validationSchema: validationSchema,

    onSubmit: async (values) => {
      let arr = [];
      console.log(values);
      console.log(values.meterFiles);
      console.log(values.startReading);
      console.log(values?.meterFiles?.length == 0);
      console.log(values?.startReading && values?.meterFiles?.length == 0);
      if (
        (values.startReading && !values.endReading) ||
        (values.startReading && values.startReading == values.endReading)
      ) {
        toast.error("End reading is required");
        return;
      }
      if (
        values?.startReading &&
        (!values?.meterFiles || values?.meterFiles?.length == 0)
      ) {
        toast.error("files are required");
        return;
      }
      if (
        values?.kmClosing &&
        (!values?.meterFiles1 || values?.meterFiles1?.length == 0)
      ) {
        toast.error("files are required");
        return;
      }
      if (
        (values.kmOpening && !values.kmClosing) ||
        (values.kmOpening && values.kmOpening == values.kmClosing)
      ) {
        toast.error("Km Closing is required");
        return;
      }

      dispatch(setLoader(true));
      if (values?.meterFiles1?.length > 0) {
        arr = [...values.meterFiles1];
      }
      if (values?.meterFiles?.length > 0) {
        arr = [...arr, ...values.meterFiles];
      }

      let formdata = new FormData();
      for (const [key, value] of Object.entries(values)) {
        if (value && fullData.includes(key)) {
          formdata.append(key, values[key]);
        }
      }
      // Object.enteries(c).forEach((x) => {
      //   console.log(x);
      //   if (values[x]) {
      //     console.log(values[x]);
      //     formdata.append(x, values[x]);
      //   }
      // });

      arr.forEach((data) => {
        formdata.append("files", data);
      });

      await updateTripDetails(formdata).then((res) => {
        dispatch(setLoader(false));
        if (res && res?.data?.statusDescription?.statusCode == 200) {
          toast.success(res.data?.statusDescription?.description);
          let e;
          formik1.handleReset(e);
          setShowModal2(true);
        }
      });
    },
  });
  useEffect(() => {
    if (
      formik.values.shiftId &&
      formik.values.siteId &&
      dateRange &&
      formik.values.vehicleTypeId
    ) {
      document.getElementById("go_for_hit")?.click();
    }
  }, [formik.values.vehicleTypeId]);

  useEffect(() => {
    calculateDetails();
  }, [formik1.values.endReading, formik1.values.kmClosing]);

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log("Form submitted:", formData);
  };

  const calculateDetails = () => {
    if (formik1.values.startReading && formik1.values.endReading) {
      const start = parseFloat(formik1.values.startReading);
      const end = parseFloat(formik1.values.endReading);
      if (!isNaN(start) && !isNaN(end)) {
        const diff = end - start;
        formik1.setFieldValue("workingHours", diff.toFixed(2));
      }
    }

    if (formik1.values.kmClosing && formik1.values.kmOpening) {
      const start = parseFloat(formik1.values.kmOpening);
      const end = parseFloat(formik1.values.kmReading);
      if (!isNaN(start) && !isNaN(end)) {
        const diff = end - start;
        formik1.setFieldValue("kmCovered", diff.toFixed(2));
      }
    }
  };

  return (
    <div className="staff-management">
      <div className="tabs-container mb-3 tb_colored">
        {vehicleList?.map((x) => {
          return (
            <>
              <button
                key={x.vehicleTypeId}
                className={`tab ${activeTab === x.name ? "active" : ""}`}
                onClick={(e) => {
                  console.log(x);
                  setActiveTab(x.name);
                  setActiveId(x.vehicleTypeId);
                  formik.setFieldValue("vehicleTypeId", x.vehicleTypeId);
                  formik.setFieldValue("vehicleName", x.name);
                }}
              >
                {x.name}
              </button>
            </>
          );
        })}
      </div>

      <div className="row mx-2 px-1 controls-container">
        <div className="col-md-2 col-12 site_div">
          <FormControl sx={{ padding: "2px" }} fullWidth>
            <InputLabel shrink={true}>
              Site <span className="text text-danger">* </span>
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={formik.values.siteIdState}
              required
              size="small"
              name="siteIdState"
              label="Projects"
              onChange={(e) => {
                formik.handleChange(e);
                // console.log(e.target.value);
                formik.setFieldValue("siteId", e.target.value.siteId);
              }}
              MenuProps={{
                disableAutoFocusItem: true, // Prevents auto-focusing the first item
                disableEnforceFocus: true, // Prevents focus trapping
                disableRestoreFocus: true, // Prevents restoring focus to input
              }}
            >
              <MenuItem value={0} style={{ fontSize: "12px" }}>
                {" "}
                Select Site
              </MenuItem>
              {sitesList.length > 0 &&
                sitesList.map((data) => {
                  return (
                    <MenuItem
                      key={data.siteId}
                      value={data}
                      style={{ fontSize: "11px" }}
                    >
                      {" "}
                      {data.siteName}
                    </MenuItem>
                  );
                })}
            </Select>
          </FormControl>
        </div>
        {/* <div className="radio-group col-md-4 col-12">
          {shiftList?.map((x, i) => {
            return (
              <>
                <label key={i}>
                  <input
                    type="radio"
                    name="status"
                    value={
                      formik.values.shiftId == x.shiftId ? "active" : "inactive"
                    }
                    checked={formik.values.shiftId == x.shiftId}
                    onChange={(e) => {
                      // setSelectedRadio(x.shiftId);
                      formik.setFieldValue("shiftId", x.shiftId);
                    }}
                  />
                  {x.name}
                </label>
              </>
            );
          })}
        </div> */}

        <div className="date-picker col-md-3 col-12">
          <div className="date-picker">
            {/* <DateRangePickerComponent
              range={dateRange}
              setRange={setDateRange}
            /> */}

            <DateRangePicker
              placeholder="Select Date Range"
              value={dateRange}
              size="lg"
              onChange={(e) => {
                console.log(e);
                setDateRange(e);
              }}
            />
            {/* <input
              type="date"
              name="tripDate"
              value={formik.values.tripDate}
              onChange={(e) => {
                // console.log(e);
                formik.handleChange(e);
              }}
            /> */}
          </div>
        </div>
        <div className="col-md-1 col-12 yellow_apply">
          <button
            className="btn yellow_btn_1"
            type="button"
            id="go_for_hit"
            onClick={(e) => {
              // console.log("submittrf");
              formik.handleSubmit(e);
            }}
          >
            {" "}
            Apply <i className="fa fa-left-arrow"></i>{" "}
          </button>

          {isMobile && (
            <button
              className="btn btn-primary mx-1  p-0  yellow_btn_2"
              type="button"
              onClick={(e) => {
                localStorage.setItem(
                  "vehicleTypeId",
                  formik.values.vehicleTypeId
                );
                localStorage.setItem("vehicleName", formik.values.vehicleName);
                navigate("/trips");
              }}
            >
              Add
            </button>
          )}
        </div>
      </div>

      <Card
        title={`${
          activeTab.charAt(0).toUpperCase() + activeTab.slice(1)
        } Trips Management`}
      >
        <form onSubmit={handleSubmit}>
          {/* <div className="container-fluid main_container"> */}
          <div className="form-row group_div">
            <Paper style={{ width: "100%" }}>
              {tripData?.length > 0 && activeId != -1 && (
                <ReactMuiTable
                  columns={columns}
                  data={paginatedData}
                  key={key}
                  pageIndex={pageIndex}
                  pageSize={pageSize}
                  totalCount={tripData?.length}
                  onPageChange={(newPage) => {
                    console.log(newPage);
                    setKey(Math.random());
                    setPageIndex(newPage);
                  }}
                  onPageSizeChange={(newSize) => {
                    console.log(newSize);
                    setKey(Math.random());
                    setPageSize(newSize);
                    setPageIndex(0);
                  }}
                />
              )}

              {allTripData?.length > 0 && activeId == -1 && (
                <ReactMuiTable
                  columns={columns1}
                  data={paginatedData1}
                  key={key1}
                  pageIndex={pageIndex1}
                  pageSize={pageSize1}
                  totalCount={allTripData?.length}
                  onPageChange={(newPage) => {
                    console.log(newPage);
                    setKey1(Math.random());
                    setPageIndex1(newPage);
                    console.log(newPage)
                  }}
                  onPageSizeChange={(newSize) => {
                    console.log(newSize);
                    setKey1(Math.random());
                    setPageSize1(newSize);
                    setPageIndex1(0);
                  }}
                />
              )}
              {tripData.length == 0 && allTripData.length == 0 && (
                <div className="d-block text-center px-5  py-5">
                  <h4>No record found</h4>
                </div>
              )}
            </Paper>
          </div>
        </form>

        <ConfimationModal
          show={showModal1}
          onHide={() => setShowModal1(false)}
          size="xl"
          onSubmit={() => {
            setShowModal1(false);
          }}
          title={
            "View Details" +
            " > " +
            detailObj?.siteName +
            " > " +
            detailObj?.vehicleName +
            " > " +
            detailObj?.vehicleNumber
          }
          hideSubmit={true}
        >
          <div className="container">
            <div className="row">
              {detailObj &&
                Object.keys(detailObj).map((x) => {
                  if (!x.includes("attachmen")) {
                    return (
                      <>
                        {detailObj[x] && !x.includes("Id") ? (
                          <div className="col-md-3 mt-2">
                            {/* {toNormalCase(x)} */}
                            <TextField
                              value={
                                toNormalCase(x).split("")[1] == "At" ||
                                x.toLowerCase().includes("tripdate") ||
                                x.toLowerCase().includes("createdat")
                                  ? moment(detailObj[x]).format("DD-MM-YYYY") +
                                    ` ${detailObj[x].split(" ")[1]}`
                                  : detailObj[x]
                              }
                              label={x ? toNormalCase(x) : ""}
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  } else {
                    return (
                      <>
                        {detailObj[x] && x.includes("attachmen") ? (
                          <div className="col-md-3 mt-2">
                            <label> Attachments </label>

                            <ul>
                              {detailObj[x]?.map((y) => {
                                return (
                                  <li>
                                    <a
                                      target="_blank"
                                      href={y.url}
                                      className="attachment_text"
                                    >
                                      {y.saveFileName}
                                    </a>
                                  </li>
                                );
                              })}
                            </ul>
                          </div>
                        ) : (
                          <></>
                        )}
                      </>
                    );
                  }
                })}
            </div>
          </div>
        </ConfimationModal>

        <ConfimationModal
          show={showModal2}
          onHide={() => setShowModal2(false)}
          size="xl"
          onSubmit={(e) => {
            console.log(formik1.values);
            formik1.handleSubmit(e);
          }}
          title={"Fill End Reading"}
          hideSubmit={true}
        >
          <div className="container">
            <div className="row">
              {/* {formik1.values.startReading && (
                <div className="row mb-3">
                  <div className="col-md-auto mt-2">
                    <TextField
                      fullWidth
                      label="Start Reading"
                      name="startReading"
                      size="small"
                      required
                      value={formik1.values.startReading}
                      // onChange={formik1.handleChange}
                      // onBlur={formik1.handleBlur}
                      error={
                        formik1.touched.startReading &&
                        Boolean(formik1.errors.startReading)
                      }
                      helperText={
                        formik1.touched.startReading &&
                        formik1.errors.startReading
                      }
                    />
                  </div>
                  <div className="col-md-auto mt-2">
                    <TextField
                      fullWidth
                      label="End Reading"
                      size="small"
                      name="endReading"
                      required
                      value={formik1.values.endReading}
                      onChange={(e) => {
                        formik1.handleChange(e);
                        // calculateDetails();
                      }}
                      onBlur={(e) => {
                        calculateDetails();
                      }}
                      error={
                        formik1.touched.endReading &&
                        Boolean(formik1.errors.endReading)
                      }
                      helperText={
                        formik1.touched.endReading && formik1.errors.endReading
                      }
                    />
                  </div>
                  <div className="col-md-auto mt-2">
                    <TextField
                      fullWidth
                      label="Working Hours"
                      size="small"
                      name="workingHours"
                      required
                      value={formik1.values.workingHours}
                      // onChange={formik1.handleChange}
                      // onBlur={formik1.handleBlur}
                      //    disabled={true}
                      error={
                        formik1.touched.workingHours &&
                        Boolean(formik1.errors.workingHours)
                      }
                      helperText={
                        formik1.touched.workingHours &&
                        formik1.errors.workingHours
                      }
                    />
                  </div>
                  <div className="col-md-3 mt-2">
                    <TextField
                      name="uploadfiles"
                      className="inp_choose"
                      type={"file"}
                      label={"Meter Image"}
                      inputProps={{
                        multiple: true,
                        style: { padding: "8.5px 14px" },
                        accept: "image/*",
                        capture: "environment",
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => {
                        let files = e.target.files;

                        if (files && files.length > 0) {
                          let fileArray = Array.from(files);
                          formik1.setFieldValue("meterFiles", fileArray);
                        }
                      }}
                    />
                  </div>
                </div>
              )}
              {formik.values.kmOpening && (
                <div className="row mb-3 ">
                  <div className="col-md-3 mt-2">
                    <TextField
                      fullWidth
                      label="KM Opening"
                      name="kmOpening"
                      //  disabled={true}
                      value={formik1.values.kmOpening}
                      // onChange={formik1.handleChange}
                      // onBlur={formik1.handleBlur}
                      size="small"
                      error={
                        formik1.touched.kmOpening &&
                        Boolean(formik1.errors.kmOpening)
                      }
                      helperText={
                        formik1.touched.kmOpening && formik1.errors.kmOpening
                      }
                    />
                  </div>

                  <div className="col-md-3 mt-2">
                    <TextField
                      fullWidth
                      label="KM Closing"
                      name="kmClosing"
                      value={formik1.values.kmClosing}
                      onChange={(e) => {
                        formik1.handleChange(e);
                        // calculateDetails();
                      }}
                      onBlur={(e) => {
                        calculateDetails();
                      }}
                      size="small"
                      error={
                        formik1.touched.kmClosing &&
                        Boolean(formik1.errors.kmClosing)
                      }
                      helperText={
                        formik1.touched.kmClosing && formik1.errors.kmClosing
                      }
                    />
                  </div>
                  <div className="col-md-3 mt-2">
                    <TextField
                      fullWidth
                      label="KM Covered"
                      name="kmCovered"
                      value={formik1.values.kmCovered}
                      // onChange={formik1.handleChange}
                      //    disabled={true}
                      // onBlur={formik1.handleBlur}
                      size="small"
                      error={
                        formik1.touched.kmCovered &&
                        Boolean(formik1.errors.kmCovered)
                      }
                      helperText={
                        formik1.touched.kmCovered && formik1.errors.kmCovered
                      }
                    />
                  </div>

                  <div className="col-md-3 mt-2">
                    <TextField
                      name="uploadfiles"
                      className="inp_choose"
                      type={"file"}
                      label={"Meter Image"}
                      inputProps={{
                        multiple: true,
                        style: { padding: "8.5px 14px" },
                        accept: "image/*",
                        capture: "environment",
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => {
                        let files = e.target.files;

                        if (files && files.length > 0) {
                          let fileArray = Array.from(files);
                          formik1.setFieldValue("meterFiles1", fileArray);
                        }
                      }}
                      // error={
                      //   errorObj?.[field.fieldValue] &&
                      //   !formData?.[field.fieldValue + "file"]
                      // }
                      // helperText={
                      //   errorObj?.[field.fieldValue] &&
                      //   !formData?.[field.fieldValue + "file"] &&
                      //   `${field?.fieldName} is required`
                      // }
                    />
                  </div>
                </div>
              )} */}

              <TripDetailsForm
                key={key}
                formFields={prefilledFields}
                prefilled={showObj}
                editData={null}
                exportAddition={(e) => {
                  console.log(e);
                }}
              />
            </div>
          </div>
        </ConfimationModal>
        {anchorEl && (
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={viewDetail}>View Trip Details </MenuItem>
            <MenuItem onClick={handleEdit}>Update Trip Details </MenuItem>
            {/* <MenuItem onClick={handleDelete}>Delete</MenuItem> */}
          </Menu>
        )}
      </Card>
    </div>
  );
};

export default TrackVehicle;
